module.exports = __webpack_public_path__ + "static/media/kaseya_bms_logo.050cbf78.png";